import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  contentContainer: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    marginRight: theme.spacing(8),
    marginLeft: theme.spacing(8),
    position: 'relative',
  },
}));

export default function PageContent({ children, extraClasses = '' }) {
  const classes = useStyles();
  return (
    <div className={`${classes.contentContainer} ${extraClasses}`}>
      {children}
    </div>
  );
}
